import {APP_CONFIG} from "../constants/global-variables.js";
const getHeaders = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  }
};

// POST accountbalanceofsuperadminallcurrency REQUEST BODY {"children_id": 12,"start_date":"2022-12-12","end_date":"2022-12-14" }
export async function getBaste({role, startDate, endDate, userId}) {
    if (userId > 0) {
      switch (role.toLowerCase()) {
        case 'administrator':
          role = 'supermanager';
          break;
        case 'supermanager':
          role = 'manager';
          break;
        case 'manager':
          role = 'agent';
          break;
        case 'agent':
          role = 'member';
          break;
      }
    }
  
    if (role.toLowerCase() === 'manager' || role.toLowerCase() === 'supermanager') {
      role = role.toLowerCase().replace('manager', 'menager');
    }

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/accountbalanceof${role.toLowerCase()}allcurrency`;

    try {
        const res = await axios.post(url, 
          {
            'start_date': startDate,
            'end_date': endDate,
            'children_id': parseInt(userId)
          },
          {...getHeaders()});
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getCasinoSlot({role, startDate, endDate, userId}) {
    if (role.toLowerCase() === 'administrator') role = 'admin';

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrgscasinobalanceof${role.toLowerCase()}`;

    try {
        const res = await axios.post(url, 
          {
            'start_date': startDate,
            'end_date': endDate,
            'children_id': parseInt(userId)
          },
          {...getHeaders()});
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getCasino({role, startDate, endDate, userId}) {
  if (role.toLowerCase() === 'administrator') role = 'admin';

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrcasinobalanceof${role.toLowerCase()}`;

  try {
      const res = await axios.post(url, 
        {
          'start_date': startDate,
          'end_date': endDate,
          'children_id': parseInt(userId)
        },
        {...getHeaders()});
      return res.data;
  } catch (err) {
      //console.log('Error getting documents', err);
  }
}

export async function getVirtual({role, startDate, endDate, userId}) {
  if (role.toLowerCase() === 'administrator') role = 'admin';

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrvirtualbalanceof${role.toLowerCase()}`;

  try {
      const res = await axios.post(url, 
        {
          'start_date': startDate,
          'end_date': endDate,
          'children_id': parseInt(userId)
        },
        {...getHeaders()});
      return res.data;
  } catch (err) {
      //console.log('Error getting documents', err);
  }
}

export async function getVipCasino({role, startDate, endDate, userId}) {
  if (role.toLowerCase() === 'administrator') role = 'admin';

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrsgcasinobalanceof${role.toLowerCase()}`;

  try {
      const res = await axios.post(url, 
        {
          'start_date': startDate,
          'end_date': endDate,
          'children_id': parseInt(userId)
        },
        {...getHeaders()});
      return res.data;
  } catch (err) {
      //console.log('Error getting documents', err);
  }
}


export async function getLiveCasino({ role, startDate, endDate, userId }) {
    if (role.toLowerCase() === 'administrator') role = 'admin';

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/allcurrlivecasinobalanceof${role.toLowerCase()}`;

    try {
        const res = await axios.post(url,
            {
                'start_date': startDate,
                'end_date': endDate,
                'children_id': parseInt(userId)
            },
            { ...getHeaders() });
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
